

import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Btn from "../shared/button/Btn";
import { approveRegisterDraft } from "../../features/admin3/admin3Slice";
import SmallSpinner from "../shared/spinners/SmallSpinner";
import moment from "moment";
import { showModal } from "../../features/modal/modalSlice";
import { setPortalMemberData } from "../../features/admin3/admin3Slice";

const Container = styled.div`
  width: 100%;
  margin-block: 5px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;
    cursor: pointer;
    .content {
      width: 100% !important;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      color: ${({ theme }) => theme.mainTextColor} !important;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .row {
        width: 100%;
        display: grid;
        grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        background-color: transparent;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          display: flex;
          align-items: center;
          justify-content: center;
          
          span {
            font-size: 20px;
          }

          .btn-wrapper{
            display: flex;
            gap: 10px;
          }
          
        }
      }
    }
  }
`;

const PanelUyeDenetimContainer = ({ item, processedItem, setProcessedItem, statusType }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const {isLoadingApproveDraft} = useSelector(state => state.admin3)

  return (
    <Container theme={theme} onClick={() => {dispatch(showModal("portalMembersControlUpdate")); dispatch(setPortalMemberData(item))}}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">
              {moment(item?.createdAt).format("LLL")}
            </div>
            <div className="col">
              {item?.yetkiliUserName}
            </div>
            <div className="col">
                {item?.yetkiliMail}
            </div>
            <div className="col">
                {item?.yetkiliPhoneNumber}
            </div>
            <div className="col">
                {item?.firmaName}
            </div>
            <div className="col">
                {item?.vergiNo}
            </div>
            <div className="col">
                {item?.firmaTypeId === 1 ? "Dijital Lojistikçi" : "Kooperatif"}
            </div>
            <div className="col">
              {
                statusType.id === 0 ?
                <div className="btn-wrapper" onClick={(e) => e.stopPropagation()}>
                  <Btn bgColor="#E85446" color="#fff" handleClick={() => {dispatch(approveRegisterDraft({id: item.id, isApproved: true })); setProcessedItem({id:item.id, type: true}); dispatch(setPortalMemberData(item))}} width={"75px"}>{(processedItem.id === item.id && processedItem.type && isLoadingApproveDraft) ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Onayla"}</Btn>
                  <Btn bgColor="#fff" color="#E85446" handleClick={() => {dispatch(showModal("portalMemberRejectedReason")); setProcessedItem({id: item.id, type: false}); dispatch(setPortalMemberData(item))}} width={"75px"}>{(processedItem.id === item.id && !processedItem.type && isLoadingApproveDraft) ? <SmallSpinner size={"20px"} color={"#E85446"} bgColor={"#fff"}/> : "Reddet"}</Btn>
                </div>
                :
                statusType.id === 1 ?
                "Kayıt Onaylandı" : "Kayıt Reddedildi"
              }
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PanelUyeDenetimContainer;
